<ion-menu side="end"
          contentId="root-component"
          type="overlay"
          menuId="right-menu">
    <ion-content>
        <ion-list class="ion-no-padding">
            <!-- Menu -->
            <ion-menu-toggle menu="right-menu">
                <ion-item color="success"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="menu" color="light"></ion-icon>
                </ion-item>
            </ion-menu-toggle>

            <!-- Users -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser && !orgService.isPI && !auth.isVendor && !auth.isSA && !auth.isAAA && !auth.isTC && !auth.isPM"
                          [routerLink]="['/' + orgService.organization.id + '/dashboard/users']"
                          replaceUrl="true"
                          routerLinkActive="menu-item--active"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="people-outline"></ion-icon>
                    <ion-text>Users</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Contracts -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser && !orgService.isAnalysis && !orgService.isPI && !auth.isVendor && !auth.isPM && !auth.isAAA && !auth.isTC"
                          [routerLink]="['/' + orgService.organization.id + '/dashboard/contracts']"
                          replaceUrl="true"
                          routerLinkActive="menu-item--active"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="documents-outline"></ion-icon>
                    <ion-text>Contracts</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- File Library -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser && !orgService.isAnalysis"
                          [routerLink]="['/' + orgService.organization.id + '/dashboard/file-library']"
                          replaceUrl="true"
                          routerLinkActive="menu-item--active"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="folder-open-outline"></ion-icon>
                    <ion-text>File Library</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Tools (previously Rehab Guide) -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser && !orgService.isAnalysis && !auth.isAAA && !auth.isTC"
                          (click)="showToolsModal()"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="construct-outline"></ion-icon>
                    <ion-text>Tools</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Settings -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser"
                          [routerLink]="['/' + orgService.organization.id + '/dashboard/settings']"
                          replaceUrl="true"
                          [queryParams]="{ segment: 'branding' }"
                          routerLinkActive="menu-item--active"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="settings-outline"></ion-icon>
                    <ion-text>Settings</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Tutorial -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser && !orgService.isAnalysis"
                          (click)="navigateToFaq()"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="book-outline"></ion-icon>
                    <ion-text>Tutorial</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Log Out -->
            <ion-menu-toggle menu="right-menu">
                <ion-item lines="full"
                          *ngIf="auth.currentUser"
                          (click)="logOut()"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="start" name="log-out-outline"></ion-icon>
                    <ion-text>Log Out</ion-text>
                </ion-item>
            </ion-menu-toggle>
        </ion-list>
    </ion-content>
</ion-menu>
